var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  d: "M7.135 3.139a1 1 0 0 1 .728.006L12.5 5l3.894-1.483a1 1 0 0 1 1.356.934v9.86a1 1 0 0 1-.644.934l-4.241 1.616a1 1 0 0 1-.728-.006L7.5 15l-3.894 1.483a1 1 0 0 1-1.356-.934v-9.86a1 1 0 0 1 .644-.934Zm8.903 2.117-.056.012-2.732.982v8.856l2.87-1.088a.2.2 0 0 0 .13-.187V5.456a.2.2 0 0 0-.268-.188ZM8.25 4.895v8.8l3.5 1.383V6.3zm-1.5 0L3.88 5.952a.2.2 0 0 0-.13.187v8.389a.2.2 0 0 0 .27.187l2.73-1.024z"
})));
export default SvgMap;